import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9h8","key":"svg-0"}],["path",{"d":"M8 13h6","key":"svg-1"}],["path",{"d":"M12.5 20.5l-.5 .5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4","key":"svg-2"}],["path",{"d":"M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879","key":"svg-3"}],["path",{"d":"M19 18v.01","key":"svg-4"}]]

const IconMessage2Pin = createReactComponent('outline', 'message-2-pin', 'Message2Pin', __iconNode);

export default IconMessage2Pin;